import React from "react";
import { FieldLabel } from "./FieldLabel";

export function FieldBlock({ label, children, className }: { label: string, children: React.ReactNode, className?: string }): JSX.Element {
  return (<div className={`relative w-[calc(100vw-80px)] md:w-full h-fit flex flex-col flex-1 items-start gap-2 py-2 px-4`.concat(className ? ` ${className}` : '')}>
    <FieldLabel text={label} />
    {children}
  </div>)
}